import React from 'react'
import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'

import { CategoryIcon } from '@mxenabled/mxui'

import { useBudgetsStore, useGlobalCopyStore } from '../../../common'
import { type DetailedCategory } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'
import { buildDynamicCopy } from '../../../core/utils/Localization'

interface RecalculateBudgetRowProps {
  category: DetailedCategory
}

export const RecalculateBudgetRow: React.FC<RecalculateBudgetRowProps> = observer(
  ({ category }) => {
    const { budgets: copy } = useGlobalCopyStore()
    const { budgets } = useBudgetsStore()

    const secondaryText = React.useMemo(() => {
      const budget = budgets.find((b) => b.category_guid === category.guid)
      const part1 = formatCurrency(category.totalAverageAmount, '0,0')
      const part2 = budget
        ? buildDynamicCopy(copy.recalculate_previous_budget, formatCurrency(budget.amount, '0,0'))
        : copy.recalculate_new_budget

      return `${part1} - ${part2}`
    }, [copy, budgets])

    return (
      <React.Fragment key={category.guid}>
        <ListItem>
          <ListItemButton>
            <ListItemAvatar>
              <CategoryIcon categoryGuid={category.guid} variant="filled" />
            </ListItemAvatar>
            <ListItemText primary={category.name} secondary={secondaryText} />
          </ListItemButton>
        </ListItem>
        <Divider />
      </React.Fragment>
    )
  },
)
